
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Extending Support </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm ">
  <div class="container">
      <h6 class="fw-bold">Navbharat "Sugam Sandhya" with Rahul Deshpande: A Soulful Evening of Music and Heritage</h6>

      <p>On the evening of 30th March 2025, music lovers gathered under the open sky for Navbharat's "Sugam Sandhya", a night of melody, harmony, and cultural celebration. Supported by the Raisoni Foundation, the event was a tribute to India's rich musical heritage.</p>

      <p>Renowned vocalist Rahul Deshpande mesmerized the audience with his soulful voice, creating an enchanting atmosphere that lingered long after the final note. As he took the stage, the vast lawn overflowed with an audience beyond capacity, a true testament to his legendary appeal.</p>

      <p>Held on the auspicious occasion of Gudi Padwa, the evening carried a deep cultural and spiritual significance. The Raisoni Foundation’s commitment to preserving Indian heritage shone through, making this musical extravaganza not just a concert, but an experience to be cherished for years to come.</p>
      <hr>
      <div class="lightBox--gallery">
        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
            <li class="col"
                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support.webp"
                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support.webp">
                <a href="Javascript:void(0);">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support.webp"
                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                    <div class="light-gallery-poster">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                    </div>
                </a>
            </li>
            <li class="col"
                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-1.webp"
                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-1.webp">
                <a href="Javascript:void(0);">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-1.webp"
                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                    <div class="light-gallery-poster">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                    </div>
                </a>
            </li>
            <li class="col"
                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-2.webp"
                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-2.webp">
                <a href="Javascript:void(0);">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-2.webp"
                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                    <div class="light-gallery-poster">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                    </div>
                </a>
            </li>

            <li class="col"
                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-3.webp"
                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-3.webp">
                <a href="Javascript:void(0);">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-3.webp"
                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                    <div class="light-gallery-poster">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                    </div>
                </a>
            </li>
            <li class="col"
                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-4.webp"
                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-4.webp">
                <a href="Javascript:void(0);">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-4.webp"
                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                    <div class="light-gallery-poster">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                    </div>
                </a>
            </li>
            <li class="col"
                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-5.webp"
                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-5.webp">
                <a href="Javascript:void(0);">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-5.webp"
                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                    <div class="light-gallery-poster">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                    </div>
                </a>
            </li>
            <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-media.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-media.webp">
            <a href="Javascript:void(0);">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/extended-support/extended-support-media.webp"
                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                <div class="light-gallery-poster">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                </div>
            </a>
        </li>
        </ul>
      </div>
  </div>
</section>
